import { FC, Ref } from 'react';

import styled, { FlattenSimpleInterpolation } from 'styled-components';

import { Modal, ModalApi, ModalProps } from '@components/Modal';

const Title = styled.h2<{ responsiveness?: FlattenSimpleInterpolation }>`
  font-size: 24px;
  font-weight: 600;
  color: ${(p) => p.theme.palette.darkGrey};
  margin: 0;
  display: flex;
  ${(p) => p.responsiveness}
`;

const PromotionInfoSection = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 16px;
  align-items: center;
  margin: 50px -40px -40px;
  padding: 14px 40px 21px;
  background-color: ${(p) => p.theme.palette.lynxWhite};
  @media (max-width: ${({ theme }) => theme.breakPoint.LARGE_1X}) {
    margin: 0px -15px -40px;
    padding: 14px 15px 21px;
  }
`;

const PromotionTitle = styled.h3`
  display: flex;
  flex-direction: column;
  color: ${(p) => p.theme.palette.darkGrey};
  font-weight: 600;
  @media (max-width: ${({ theme }) => theme.breakPoint.LARGE_1X}) {
    font-size: 16px;
  }
`;
const PromotionDescription = styled.p`
  margin: 8px 0 0;
  font-size: 14px;
  line-height: 1.71;
  text-align: center;
  color: ${(p) => p.theme.palette.matterHorn};
`;

type Common = ModalProps & {
  modal?: Ref<ModalApi>;
  titleResponsiveness?: FlattenSimpleInterpolation;
};
type Props =
  | {
      promotionTitle: string;
      promotionDescription: string;
      noPromotionInfo?: false;
    }
  | {
      promotionTitle?: never;
      promotionDescription?: never;
      noPromotionInfo: true;
    };

const BasePromotionModal: FC<Props & Common> = ({
  modal,
  promotionTitle,
  promotionDescription,
  title,
  width,
  children,
  titleResponsiveness = undefined,
  noPromotionInfo,
  ...rest
}) => {
  const modalTitle = title ? (
    <Title responsiveness={titleResponsiveness}>{title}</Title>
  ) : null;
  return (
    <Modal ref={modal} title={modalTitle} width={width} {...rest}>
      {children}
      {noPromotionInfo ? null : (
        <PromotionInfoSection>
          <PromotionTitle>{promotionTitle}</PromotionTitle>
          <PromotionDescription>{promotionDescription}</PromotionDescription>
        </PromotionInfoSection>
      )}
    </Modal>
  );
};

export default BasePromotionModal;
